// Hudl Instat FIBA shot-chart geometry — extracted verbatim from Hudl's
// `player-details-basketball-map-svg__FIBA` SVG (viewBox 0 0 524 332).
// Coordinate transform validated against player 3260 (16/204 zone-attempt
// diff vs Hudl, residuals are boundary shots).

export const SVG_W = 524;
export const SVG_H = 332;

// API (FIBA half-court meters: x=0..28 from far baseline, y=0..15)
//   → SVG (524 x 332, basket at top-center, x mirrored so y=0 lands right)
export function shotToSvg(shot) {
  return {
    sx: (15 - shot.y) * (SVG_W / 15),
    sy: (28 - shot.x) * 32.5,
  };
}

// 14 zones in Hudl-numbering order. `label` is the exact CSS box used by
// Hudl to anchor the "% / made — att" text.
export const ZONES = [
  {
    id: 'zone_1',
    kind: 'rect',
    rect: { x: 0, y: 0, width: 42.97, height: 96.13 },
    label: { left: 19.39, top: 46.48, width: 0, height: 0 },
  },
  {
    id: 'zone_2',
    kind: 'path',
    d: 'M43.6,96.13v.54h.22a221.89,221.89,0,0,0,37.25,84.72l51.22-37,.15.21A159.76,159.76,0,0,1,110.87,0H43.56V96.13Z',
    label: { left: 73.36, top: 56.44, width: 32.28, height: 32.8 },
  },
  {
    id: 'zone_3',
    kind: 'path',
    d: 'M149.56,163.8a160.13,160.13,0,0,0,29.87,23.52l40.67-67.46A80.63,80.63,0,0,1,199.44,0h-88A159.25,159.25,0,0,0,103,51.36,158,158,0,0,0,149.56,163.8Z',
    label: { left: 146.72, top: 69.72, width: 39.34, height: 32.8 },
  },
  {
    id: 'zone_4',
    kind: 'path',
    d: 'M262,131A80,80,0,0,0,323.76,0H200.24A80,80,0,0,0,262,131Z',
    label: { left: 262, top: 53.12, width: 39.34, height: 32.8 },
  },
  {
    id: 'zone_5',
    kind: 'path',
    d: 'M303.27,120.23l.3-.17,40.76,67.41a160.12,160.12,0,0,0,30.11-23.66A158,158,0,0,0,421,51.36,159.25,159.25,0,0,0,412.56,0h-88a80.62,80.62,0,0,1-21.29,120.23Z',
    label: { left: 377.28, top: 69.72, width: 41.73, height: 32.8 },
  },
  {
    id: 'zone_6',
    kind: 'path',
    d: 'M413.13,0a159.74,159.74,0,0,1-21.53,144.49l.1.07h0l51.17,36.91a221.87,221.87,0,0,0,37.31-84.8h.22v-.54h.06V0Z',
    label: { left: 450.64, top: 56.44, width: 26.74, height: 32.8 },
  },
  {
    id: 'zone_7',
    kind: 'rect',
    rect: { x: 481.04, y: 0, width: 42.96, height: 96.13 },
    label: { left: 504.61, top: 46.48, width: 41.73, height: 32.8 },
  },
  {
    id: 'zone_8',
    kind: 'path',
    d: 'M132.63,144.83l-51.22,37a224.2,224.2,0,0,0,23.06,27,222.34,222.34,0,0,0,96.4,56.76l17.23-60.82A159.85,159.85,0,0,1,132.63,144.83Z',
    label: { left: 136.24, top: 202.52, width: 32.28, height: 32.8 },
  },
  {
    id: 'zone_9',
    kind: 'path',
    d: 'M343.84,187.77l-40.77-67.43a80.67,80.67,0,0,1-82.45-.19l-40.68,67.47a159.43,159.43,0,0,0,163.91.14Z',
    label: { left: 262, top: 172.64, width: 39.34, height: 32.8 },
  },
  {
    id: 'zone_10',
    kind: 'path',
    d: 'M322.13,265.94l-17.25-60.82a160.53,160.53,0,0,1-86.22-.13h0l-17.23,60.82a224.55,224.55,0,0,0,120.7.12Z',
    label: { left: 262, top: 242.36, width: 32.28, height: 32.8 },
  },
  {
    id: 'zone_11',
    kind: 'path',
    d: 'M391.34,145h0l-.09-.06a160.43,160.43,0,0,1-46.84,43.09l-.3.18A158.69,158.69,0,0,1,305.44,205l17.25,60.81a222.49,222.49,0,0,0,96.84-56.89,224.23,224.23,0,0,0,23-26.95Z',
    label: { left: 387.76, top: 202.52, width: 41.73, height: 32.8 },
  },
  {
    id: 'zone_12',
    kind: 'path',
    d: 'M80.72,181.87l-.11-.15h0a222.26,222.26,0,0,1-37.37-85H0V332H182.07l18.64-65.8A223.7,223.7,0,0,1,80.72,181.87Z',
    label: { left: 47.16, top: 242.36, width: 33.04, height: 32.8 },
  },
  {
    id: 'zone_13',
    kind: 'path',
    d: 'M262,274.73a223.5,223.5,0,0,1-60.73-8.37L182.67,332H340.87l-18.59-65.51A223.52,223.52,0,0,1,262,274.73Z',
    label: { left: 262, top: 302.12, width: 32.28, height: 32.8 },
  },
  {
    id: 'zone_14',
    kind: 'path',
    d: 'M443.33,181.8h0l0,.06a223.69,223.69,0,0,1-120.44,84.46L341.47,332H524V96.71H480.76A222.26,222.26,0,0,1,443.33,181.8Z',
    label: { left: 480.48, top: 242.36, width: 33.04, height: 32.8 },
  },
];

// Classify a shot into one of the 14 zones — using Hudl's exact algorithm
// reverse-engineered from their main.bundle.js (class jPt / detectExtended).
// Operates on COURT coordinates in meters (shot.x, shot.y), not SVG units.
// Validated against player 3260 last-10-games dataset: 96/96 shots match
// Hudl per-zone counts with 0 diff.
const FIBA = {
  center: { x: 26.425, y: 7.5 },
  radius: [2.45, 4.884, 6.75], // restricted area, key arc, 3pt arc
  zone_1: { x: 25.1, y: 14.1 },
  zone_7: { x: 25.1, y: 0.9 },
  line_3_9:   { x: 22.2, y: 10.0503 },
  line_5_9:   { x: 22.2, y: 4.9496 },
  line_2_8:   { x: 21, y: 15 },
  line_8_10:  { x: 0,  y: 15 },
  line_6_11:  { x: 21, y: 0 },
  line_10_11: { x: 0,  y: 0 },
  line_12_13: { x: 0,  y: 15 },
  line_13_14: { x: 0,  y: 0 },
};

function inCircle(c, r, p) {
  return (p.x - c.x) ** 2 + (p.y - c.y) ** 2 < r * r;
}

// Hudl's `isLeft`: is `testPt` below the line passing through `linePt` and the
// basket `center`. Despite the name, it's a vertical (y) comparison along the
// ray from the basket through the boundary point.
function isLeft(linePt, testPt) {
  return !(
    (testPt.x - linePt.x) * (FIBA.center.y - linePt.y) /
      (FIBA.center.x - linePt.x) +
      linePt.y >
    testPt.y
  );
}

export function classifyShot(shot) {
  const p = { x: shot.x, y: shot.y };
  if (inCircle(FIBA.center, FIBA.radius[0], p)) return 'zone_4';
  if (inCircle(FIBA.center, FIBA.radius[1], p)) {
    if (isLeft(FIBA.line_3_9, p)) return 'zone_3';
    if (isLeft(FIBA.line_5_9, p)) return 'zone_9';
    return 'zone_5';
  }
  if (p.x > FIBA.zone_1.x && p.y > FIBA.zone_1.y) return 'zone_1';
  if (p.x > FIBA.zone_7.x && p.y < FIBA.zone_7.y) return 'zone_7';
  if (inCircle(FIBA.center, FIBA.radius[2], p)) {
    if (isLeft(FIBA.line_2_8, p)) return 'zone_2';
    if (isLeft(FIBA.line_8_10, p)) return 'zone_8';
    if (isLeft(FIBA.line_10_11, p)) return 'zone_10';
    if (isLeft(FIBA.line_6_11, p)) return 'zone_11';
    return 'zone_6';
  }
  if (isLeft(FIBA.line_12_13, p)) return 'zone_12';
  if (isLeft(FIBA.line_13_14, p)) return 'zone_13';
  return 'zone_14';
}
